

















import { Vue, Component, Prop } from 'vue-property-decorator';
import { EIconSize } from '@getaccept/lib-ui';
import HandEmoji from '../assets/hand-emoji.svg';
import type { IUser } from '@signing-page/users/types/user';

@Component({
  components: {
    HandEmoji,
  },
  data: () => ({
    EIconSize,
  }),
})
export default class ChatSystemMessage extends Vue {
  @Prop() sender: IUser;

  handleClose() {
    this.$emit('close');
  }

  handleClick() {
    this.$emit('click');
  }
}
